module.exports = __webpack_public_path__ + "img/sk-bnt-gelombang-3.04826b74.png";